import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './plugins/axios'

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue;

import Cookies from 'js-cookie'
Vue.prototype.$cookie = Cookies;

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle);

import Qs from 'qs'
Vue.prototype.$qs = Qs;

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);

import 'vant/lib/index.css';
import {Popup} from 'vant';
Vue.use(Popup);

import {Picker} from 'vant';
Vue.use(Picker);

import {DatetimePicker} from 'vant';
Vue.use(DatetimePicker);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#main')
